import styled from 'styled-components';

import {
  UpArrowSmallIcon as BaseUpArrowSmallIcon,
  DownArrowSmallIcon as BaseDownArrowSmallIcon,
} from '../../icons';
import { colors, boxShadows, fontSizes, fontWeights } from '../../theme';
import { ButtonPrimitive } from '../Button';

export const TableOfContentRoot = styled.menu`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  background-color: ${colors.white};
  border-radius: 12px;
  box-shadow: ${boxShadows.elevation2};
`;

interface MenuItemProps {
  $isSelected: boolean;
  $isDisabled?: boolean;
}

export const MenuItem = styled(ButtonPrimitive)<MenuItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: ${fontSizes.m};
  font-weight: ${({ $isSelected, 'aria-expanded': isExpanded }) =>
    isExpanded || $isSelected ? fontWeights.medium : fontWeights.regular};
  color: ${colors.night};
  text-transform: uppercase;
  pointer-events: ${({ $isDisabled }) => $isDisabled && 'none'};
  background-color: ${({ theme, $isSelected }) =>
    $isSelected
      ? theme.semantic.color['non-interactable'].bg['colored-primary']
      : 'transparent'};
  opacity: ${({ $isDisabled }) => $isDisabled && '0.5'};
  outline: none;
  border: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover,
  &:focus-visible {
    background-color: ${({ $isDisabled, $isSelected }) =>
      !$isSelected && !$isDisabled && colors.pearl};
  }
`;

export const MenuSubItem = styled(MenuItem)`
  padding-left: 32px;
  font-size: ${fontSizes.xs};
`;

export const UpArrowSmallIcon = styled(BaseUpArrowSmallIcon)`
  width: 24px;
  height: 24px;
`;

export const DownArrowSmallIcon = styled(BaseDownArrowSmallIcon)`
  width: 24px;
  height: 24px;
`;
